import React from 'react';
import { Typography } from 'antd';
import './EndpointHeader.css';

const { Text, Title } = Typography;

/**
 * EndpointHeader - Displays the category label, title, and description for an API endpoint
 *
 * @param {string} category - The API category (e.g., "Documentation API")
 * @param {string} title - The endpoint title/summary
 * @param {string} description - The endpoint description
 */
const EndpointHeader = ({ category, title, description }) => {
  return (
    <div className="endpoint-header">
      {category && <Text className="endpoint-header-category">{category}</Text>}
      {title && (
        <Title level={2} className="endpoint-header-title">
          {title}
        </Title>
      )}
      {description && <Text className="endpoint-header-description">{description}</Text>}
    </div>
  );
};

export default EndpointHeader;
